import BaseButton from 'app/components/common/BaseButton';
import React, { FunctionComponent } from 'react';
import { GetHistory } from 'app/components/router/History';

interface IProps {
  className?: string;
}

/**
 * Helper for reloading the page and overriding history warnings.
 */
const ReloadButton: FunctionComponent<IProps> = ({ className, children }) => (
  <GetHistory>{(history) => (
    <BaseButton
      className={className}
      onClick={() => {
        history.dangerouslyConfirmNextBrowserNavigation();
        history.reload();
      }}
      type="button"
    >
      {children}
    </BaseButton>
  )}</GetHistory>
);

export default ReloadButton;
